import React, { useState } from 'react';

import { ModalProps } from '@tager/web-components';

import { useLockBodyScroll } from '@/hooks/useLockBodyScroll';
import { OptionType } from '@/typings/common';

import { AlfaLeasingFormView } from './AlfaLeasingFormView';
import { AlfaLeasingFormState, AlfaLeasingFormViewProps } from './types';
import { AlfaLeasingQuizFieldsType } from './components/AlfaLeasingQuiz/types';
import { AlfaLeasingFormFields } from './components/AlfaLeasingForm/types';

type Props = ModalProps<{
  alfaLeasingQuizResult: boolean;
  dealers: OptionType[];
  onSubmitAlfaLeasingQuiz?: (
    values: AlfaLeasingQuizFieldsType
  ) => Promise<void>;
  onSubmitAlfaLeasingForm?: (values: AlfaLeasingFormFields) => Promise<void>;
  onCloseButton?: () => void;
}>;

function AlfaLeasingFormModal({ innerProps, closeModal }: Props) {
  const {
    alfaLeasingQuizResult,
    dealers,
    onSubmitAlfaLeasingQuiz,
    onSubmitAlfaLeasingForm,
    onCloseButton,
  } = innerProps;
  const [state, setState] = useState(AlfaLeasingFormState.LeasingIntro);

  useLockBodyScroll();

  const props = React.useMemo((): AlfaLeasingFormViewProps => {
    switch (state) {
      case AlfaLeasingFormState.LeasingIntro:
        return {
          state,
          props: {
            onClose: () => {
              closeModal();
              onCloseButton?.();
            },
            onNextStep: () => {
              setState(AlfaLeasingFormState.LeasingQuiz);
            },
          },
        };

      case AlfaLeasingFormState.LeasingQuiz:
        return {
          state,
          props: {
            onSubmitAlfaLeasingQuiz: async (values) => {
              await onSubmitAlfaLeasingQuiz?.(values).then(() => {
                setState(AlfaLeasingFormState.LeasingForm);
              });
            },
            onClose: () => {
              closeModal();
              onCloseButton?.();
            },
          },
        };

      case AlfaLeasingFormState.LeasingForm:
        return {
          state,
          props: {
            onSubmitAlfaLeasingForm,
            onClose: () => {
              closeModal();
              onCloseButton?.();
            },
            dealers,
            isApproved: alfaLeasingQuizResult,
          },
        };
    }
  }, [closeModal, onSubmitAlfaLeasingForm, onSubmitAlfaLeasingQuiz, state]);

  return <AlfaLeasingFormView {...props} />;
}

export default AlfaLeasingFormModal;
